import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from "@angular/common/http";
import {Injectable} from "@angular/core";

import {SOURCE_TYPE_HEADER_NAME, SOURCE_TYPE_UI} from "framework/services/source-type-interceptor/source-type";

import {Observable} from "rxjs";

@Injectable({providedIn: "root"})
export class SourceTypeInterceptor implements HttpInterceptor
{
    public intercept(req: HttpRequest<any>,
                     next: HttpHandler): Observable<HttpEvent<any>>
    {
        return next.handle(req.clone({setHeaders: {[SOURCE_TYPE_HEADER_NAME]: SOURCE_TYPE_UI}}));
    }
}
